import { render, staticRenderFns } from "./AudienceSelect.vue?vue&type=template&id=175875c2&scoped=true"
import script from "./AudienceSelect.vue?vue&type=script&lang=ts"
export * from "./AudienceSelect.vue?vue&type=script&lang=ts"
import style0 from "./AudienceSelect.vue?vue&type=style&index=0&id=175875c2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175875c2",
  null
  
)

export default component.exports